import View from 'ln/view/View';

import {Module, ModuleRequestHandler} from './Module';
import {Module as template} from 'templates/components/module';


export class ModuleView extends View<Module> implements ModuleRequestHandler {

    private lastKnownScrollPosition_: number;

    public constructor() {
        super({ template });
    }

    protected init(): void {
        this.data.request = this;

        window.addEventListener('scroll', () => {
            let scroll = window.scrollY / (window.innerHeight * 0.33);
            if (scroll > 1) scroll = 1;
            let opacity = 1 - Math.pow(scroll, 2);
            this.data.scrollHintOpacity = opacity;
        });
    }

    public navigateToChapterList(): void {
        const top = window.scrollY + document.querySelector('#chapters').getBoundingClientRect().top - 5;
        window.scrollTo({ behavior: 'smooth', top });
    }

    public restoreScroll(): void {
        window.scrollTo(0, this.lastKnownScrollPosition_);
    }

    public saveScroll(): void {
        this.lastKnownScrollPosition_ = window.scrollY;
    }

    public scrollToTop(): void {
        window.scrollTo(0, 0);
    }
}
